var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6529 3.20709C13.0432 2.81654 13.6763 2.81628 14.0669 3.2065L15.7923 4.9299C16.1831 5.32028 16.1834 5.95361 15.7929 6.34432L7.64813 14.4935C7.50885 14.6329 7.3315 14.728 7.13835 14.7669L3.50003 15.5L4.23445 11.866C4.2734 11.6732 4.36832 11.4962 4.50733 11.3571L12.6529 3.20709Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.35d1a24f7d44e6c45390aad19592a667.svg";
export { ForwardRef as ReactComponent };